// Gerado em build por scripts/sync-app-version.js
export const APP_VERSION = '1.4.3-cache-fix';
